/**
 * ChannelsChoice – SVG icon.
 */
import Screen from '@screen';

export default function ChannelsChoiceIcon({
  width,
  height,
  margin,
}: {
  width?: number;
  height?: number;
  margin?: string;
}) {
  return (
    <svg
      width={(width ? width : 85) * Screen.widthRatio}
      height={(height ? height : 77) * Screen.widthRatio}
      viewBox='0 0 85 77'
      style={{ margin: margin ? margin : 0 }}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='2'
        y='2'
        width='48.7674'
        height='18.3256'
        rx='4'
        stroke='url(#paint0_linear_settings_channelsChoice)'
        strokeWidth='4'
      />
      <rect
        x='2'
        y='55.7209'
        width='48.7674'
        height='18.3256'
        rx='4'
        stroke='url(#paint1_linear_settings_channelsChoice)'
        strokeWidth='4'
      />
      <rect
        x='2'
        y='28.8605'
        width='29.0697'
        height='18.3256'
        rx='4'
        stroke='url(#paint2_linear_settings_channelsChoice)'
        strokeWidth='4'
      />
      <rect
        x='59.3022'
        y='2'
        width='23.6977'
        height='18.3256'
        rx='4'
        stroke='url(#paint3_linear_settings_channelsChoice)'
        strokeWidth='4'
      />
      <rect
        x='59.3022'
        y='55.7209'
        width='23.6977'
        height='18.3256'
        rx='4'
        stroke='url(#paint4_linear_settings_channelsChoice)'
        strokeWidth='4'
      />
      <rect
        x='39.6047'
        y='28.8605'
        width='43.3953'
        height='18.3256'
        rx='4'
        stroke='url(#paint5_linear_settings_channelsChoice)'
        strokeWidth='4'
      />
      <defs>
        <linearGradient
          id='paint0_linear_settings_channelsChoice'
          x1='26.3837'
          y1='4'
          x2='26.3837'
          y2='18.3256'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_settings_channelsChoice'
          x1='26.3837'
          y1='57.7209'
          x2='26.3837'
          y2='72.0465'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_settings_channelsChoice'
          x1='16.5349'
          y1='30.8605'
          x2='16.5349'
          y2='45.1861'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_settings_channelsChoice'
          x1='71.151'
          y1='4'
          x2='71.151'
          y2='18.3256'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_settings_channelsChoice'
          x1='71.151'
          y1='57.7209'
          x2='71.151'
          y2='72.0465'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_settings_channelsChoice'
          x1='61.3023'
          y1='30.8605'
          x2='61.3023'
          y2='45.1861'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#57FFD9' />
          <stop offset='1' stopColor='#00CFA0' />
        </linearGradient>
      </defs>
    </svg>
  );
}
